// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_72-6";
export var headerCell = "_72-2";
export var loadingStateContent = "_72-8";
export var rowWrapper = "_72-4";
export var stickyAggregationCell = "_72-b";
export var stickyAggregationRow = "_72-7";
export var stickyColumnCell = "_72-a";
export var stickyColumnHeaderCell = "_72-9";
export var table = "_72-1";
export var virtualRowWrapper = "_72-5";
export var virtualTableBodyFiller = "_72-d";
export var virtualTableBodyFillerBottom = "_72-e";
export var virtualTableContainer = "_72-0";
export var virtualTableContainerFill = "_72-c";
export var white = "_72-3";